<h1 mat-dialog-title>{{ "ORDER.IMAGES.IMAGE_GALLERY_DIALOG_TITLE" | translate }}</h1>
<mat-dialog-content>
	<div class="cass-image-gallery-dialog-scrollable-content">
		<div *ngFor="let item of items" class="cass-image-gallery-item-box" [ngClass]="{ 'selected': item.id === selectedItem?.id }" (click)="selectItem(item)">
			<div class="cass-image-gallery-item-card">
				<div class="cass-image-gallery-dialog-image-frame">
					<img [src]="item.url" class="cass-image-gallery-dialog-item-box-image" />
				</div>
				<div class="cass-image-gallery-dialog-item-box-text">{{ item.label }}</div>
			</div>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-raised-button [disabled]="!selectedItem" (click)="dialogOk()" color="primary">{{ "ACTION_BUTTON_LABELS.OK" | translate }}</button>
	<button mat-button (click)="dialogCancel()">{{ "ACTION_BUTTON_LABELS.CANCEL" | translate }}</button>
</mat-dialog-actions>
